import { history } from "./history"
import { Map } from "immutable"

type FilterKey = 'waar' | 'wanneer' | 'categorie'
type FilterParams = Map<FilterKey, string>

export const setFilterParam = (key: FilterKey, value: string, pathname?: string): void => {
  let params = getCurrentFilterParams()

  params = value && value != "" 
    ? params.set(key, value) 
    : params.remove(key)

  pathname = pathname ? pathname : window.location.pathname
  let query = createFilterQuery(params)

  history.push(`${pathname}${query}`)
}

export const createFilterQuery = (filterParams: FilterParams): string => {
  if (filterParams.isEmpty()) return ''

  // @ts-ignore
  let search = new URLSearchParams(filterParams.map((value, key) => [key, value]).toArray())

  return `?${search.toString()}`
}

export const getCurrentFilterParams = (): FilterParams => {
  let params = new URLSearchParams(history.location.search)
  let filterParams: FilterParams = Map()
  
  // @ts-ignore
  params.forEach((value, key) => {
    if (key == 'wanneer' || key == 'waar' || key == 'categorie') {
      filterParams = filterParams.set(key, value)
    }
  })

  return filterParams
}

export const getCurrentFilterQuery = (): string => (
  createFilterQuery(
    getCurrentFilterParams()
  )
)